import AppSkeleton from "./AppSkeleton";
import styles from "./skeletons.module.scss";
import { baseColor, highlightColor } from "../../constants/skeletonColor";

const SKELETON_LINES = 4;

const FullScreenSkeleton = () => {
  return (
    <div className={styles.kycSkeletonContainer}>
      <div className={styles.kycSkeletonHeader}>
        <div>
          <AppSkeleton
            height={34}
            width={34}
            variant="circular"
            baseColor={baseColor()}
            highlightColor={highlightColor()}
          />
        </div>
        <div>
          <AppSkeleton
            height={25}
            width="60vw"
            baseColor={baseColor()}
            highlightColor={highlightColor()}
          />
        </div>
        <div>
          <AppSkeleton
            height={34}
            width={34}
            variant="circular"
            baseColor={baseColor()}
            highlightColor={highlightColor()}
          />
        </div>
      </div>
      <div className={styles.kycSkeletonCenter}>
        {Array.from({ length: SKELETON_LINES }).map((_, index) => (
          <div className={styles.padding} key={index}>
            <AppSkeleton
              height={60}
              baseColor={baseColor()}
              highlightColor={highlightColor()}
            />
          </div>
        ))}
        <div className={styles.kycSkeletonBottom}>
          <AppSkeleton
            height={60}
            baseColor={baseColor()}
            highlightColor={highlightColor()}
          />
        </div>
      </div>
    </div>
  );
};
export default FullScreenSkeleton;
